/**
 * Copyright (c) 2025 Adaptive Chaos Labs, LLC
 * All rights reserved.
 */

/**
 * Contextual-sidebar rail state (#683 D5).
 *
 * The migration retires the old resizable sidebar and its two keys
 * (`adminConsole.sidebarWidth`, `adminConsole.sidebarCollapsed`) in favour of
 * this single collapsed flag — a one-group list has a natural width, so the
 * only choice left is rail or full.
 *
 * Lives outside the component module so it can be shared (react-refresh only
 * allows component exports from a `.tsx` component file).
 */

export const RAIL_STORAGE_KEY = 'adminConsole.railCollapsed';

export function readRailCollapsed(): boolean {
  if (typeof window === 'undefined') return false;
  return window.localStorage.getItem(RAIL_STORAGE_KEY) === 'true';
}

export function writeRailCollapsed(collapsed: boolean): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(RAIL_STORAGE_KEY, String(collapsed));
}
